// VRG-675 — the source-channel field (People, Companies, GTM → Sales), as the platform shows it.
//
// The value list and labels are NOT here: they are `SOURCE_CHANNELS` / `SOURCE_CHANNEL_META`
// in @repo/types, the same list the API validates and migration 0136's CHECK enforces. This
// file only adapts them to the platform's controls, so a fourth copy of the list never exists.
import { isSourceChannel, SOURCE_CHANNELS, SOURCE_CHANNEL_META, type SourceChannel } from '@repo/types'

import type { SelectItem } from 'components/input/fields/SelectField'

/** What a person or company with no recorded channel reads as. Never "Direct": nobody said. */
export const NOT_RECORDED_LABEL = 'Not recorded'
/** The SelectField value for "clear it" (SelectField values are strings). */
export const NO_SOURCE_CHANNEL = ''

/** Tolerant on purpose: a filter drawer hands renderers the facet LABEL, not the key. */
export const sourceChannelLabel = (c: SourceChannel | string | null | undefined): string =>
  isSourceChannel(c) ? SOURCE_CHANNEL_META[c].label : typeof c === 'string' && c ? c : NOT_RECORDED_LABEL

/** In Traction order (#1..#19), each with its number so it matches the Channels page. */
export const SOURCE_CHANNEL_OPTIONS: SelectItem[] = [...SOURCE_CHANNELS]
  .sort((a, b) => SOURCE_CHANNEL_META[a].number - SOURCE_CHANNEL_META[b].number)
  .map((c) => ({ value: c, label: SOURCE_CHANNEL_META[c].label, rightLabel: `#${SOURCE_CHANNEL_META[c].number}` }))

/** For a picker: "Not recorded" first, so clearing is a choice, then the channels. */
export const SOURCE_CHANNEL_PICKER_OPTIONS: SelectItem[] = [
  { value: NO_SOURCE_CHANNEL, label: NOT_RECORDED_LABEL },
  ...SOURCE_CHANNEL_OPTIONS,
]
